import { useMutation } from 'react-query'

import { APIError } from '../../../utils'
import { voidDaybookTransaction } from '../query-api'

export enum VoidDaybookTransactionMode {
  Reverse = 'reverse',
  Void = 'void',
}

export interface VoidDaybookTransactionParams {
  daybookTransactionId: string
  mode: VoidDaybookTransactionMode
}

interface UseVoidDaybookTransactionProps {
  onError?: (error: APIError | undefined, params: VoidDaybookTransactionParams) => void
  onSuccess?: (data: void, params: VoidDaybookTransactionParams) => void
}

export const useVoidDaybookTransaction = (props?: UseVoidDaybookTransactionProps) => {
  const { onError, onSuccess } = props || {}

  const {
    mutate: voidTransaction,
    isLoading: isProcessing,
    ...rest
  } = useMutation(
    ({ daybookTransactionId }: VoidDaybookTransactionParams) => voidDaybookTransaction({ daybookTransactionId }),
    { onSuccess, onError },
  )

  return { voidTransaction, isProcessing, ...rest }
}
